import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import App from './App'
import msalInstance from './config/msalConfig'
import rootReducer from './store'

msalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult
      const { account } = payload
      msalInstance.setActiveAccount(account)
    }

    if (event.eventType === EventType.LOGOUT_SUCCESS) {
      localStorage.clear()
      sessionStorage.clear()
    }
  })

  const app = document.getElementById('root') as HTMLElement
  const root = createRoot(app)

  root.render(
    <Provider store={rootReducer}>
      <App pca={msalInstance} />
    </Provider>
  )
})
